import React from "react";
import SplashScreen from "./components/SplashScreen";

/**
 * =========================================================================
 * NOTE: The original home page has been fully backed up to:
 *       `src/App.backup.js`
 *
 * To restore the original home page at any time:
 *   import OriginalApp from "./App.backup";
 *   export default OriginalApp;
 * =========================================================================
 */

export default function App() {
  return <SplashScreen />;
}
